import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
	IRQRamittance,
	IRQRamittanceListPayload,
	IRQRamittanceResponse,
} from "../models/RQRamittance";

import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const RQRamittanceService = {
	getRQRamittance: async (
		clientId: string,
		remittanceFrequencyId: string | undefined,
		managedBy: number,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IRQRamittanceListPayload
		| IServerError
		| IResponse
		| IRQRamittanceResponse[]
		| null
	> => {
		if (!remittanceFrequencyId) return null;
		try {
			const response: AxiosResponse<IRQRamittanceListPayload> =
				await http.get<IRQRamittanceListPayload>(
					"/v1/rq-remittance/?client_id=" +
						clientId +
						"&remittance_frequency_id=" +
						remittanceFrequencyId +
						"&tax_year=" +
						taxYear +
						"&managed_by=" +
						managedBy,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getRQRamittanceSavedFrequency: async (
		clientId: string,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<
		| IRQRamittanceListPayload
		| IServerError
		| IResponse
		| IRQRamittanceResponse[]
		| null
	> => {
		try {
			const response: AxiosResponse<IRQRamittanceListPayload> =
				await http.get<IRQRamittanceListPayload>(
					"/v1/rq-remittance/" + clientId + "/?tax_year=" + taxYear,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	create: async (
		requestPayload: any,
	): Promise<IRQRamittance | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IRQRamittance> =
				await http.put<IRQRamittance>("/v1/rq-remittance/", requestPayload);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createHSF: async (
		requestPayload: any,
	): Promise<IRQRamittance | IServerError | IResponse | any> => {
		// const fixedHSf = [
		// 	{
		// 		businessStartedBefore: requestPayload.businessStartedBefore,
		// 		totalGrossPaid: requestPayload.totalGrossPaid,
		// 	},
		// ];
		// return new Promise((resolve) => setTimeout(() => resolve(fixedHSf), 1000));
		try {
			const response: AxiosResponse<IRQRamittance> =
				await http.post<IRQRamittance>("/v1/hsf-profile/", requestPayload);
			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createCSST: async (
		requestPayload: any,
	): Promise<IRQRamittance | IServerError | IResponse | any> => {
		// const fixedCSST = [
		// 	{
		// 		rate: requestPayload.businessStartedBefore,
		// 		dateEffective: requestPayload.dateEffective,
		// 	},
		// ];
		// return new Promise((resolve) => setTimeout(() => resolve(fixedCSST), 1000));
		try {
			const response: AxiosResponse<IRQRamittance> =
				await http.post<IRQRamittance>("/v1/csst-profile/", requestPayload);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	delRQRemittance: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IRQRamittance> =
				await http.delete<IRQRamittance>(`/v1/csst-profile/${delPayload.id}/`);

			if (response.status === 204) {
				return "Rate has been deleted successfully.";
			} else if (response.status === 200) {
				return "Rate has been deleted successfully.";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getRemittanceFrequencyDDL: async (): Promise<
		any | IServerError | IResponse | null | any
	> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/remittance-frequency/remittance-frequency-ddl`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getCSSTProfileDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null | any> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/csst-profile/csst-profile-ddl?client_id=${clientId}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getCSSTProfileDataById: async (
		id: null | string,
	): Promise<any | IServerError | IResponse | null | any> => {
		if (!id) return null;
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/csst-profile/${id}/`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getHSFDataByClientIdAndTaxyear: async (
		clientId: string,
		taxYear: number,
		// id: null | string,
	): Promise<any | IServerError | IResponse | null | any> => {
		// if (!id) return null;

		// let fixed = {
		// 	_id: {
		// 		$oid: "69df65bb95b4f7b4e9cd954b",
		// 	},
		// 	createdByEmail: "affansukhera99@gmail.com",
		// 	createdByExternalId: "68db860d7b2590b5034a81e3",
		// 	createdAt: null,
		// 	businessStartedBeforeYear: 100,
		// 	totalGrossPaidInYear: 120,
		// 	taxYear: 2026,
		// 	clientId: "68db990a513b66617fead1d4",
		// 	id: "6a393c841f38e787bbdebbe6",
		// 	hsfRate: 3.55,
		// 	updatedAt: null,
		// 	updatedByEmail: null,
		// 	updatedByExternalId: null,
		// };

		// return new Promise((resolve) => setTimeout(() => resolve(fixed), 1000));
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`v1/hsf-profile/${clientId}/?tax_year=${taxYear}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 404) {
				return [];
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 404) {
				return [];
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createRqRemittanceFrequency: async (
		clientId: string,
		remittanceFrequencyId: string | undefined,
		managedBy: number,
		taxYear: number,
		navigateToLogout: (path: string) => void,
	): Promise<IRQRamittance | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IRQRamittance> =
				await http.post<IRQRamittance>(
					`/v1/rq-remittance/?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`,
				);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	exportRQRemittanceExcelReport: async (
		clientId: string,
		remittanceFrequencyId: string,
		taxYear: number,
		managedBy: number,
	): Promise<any | IServerError | IResponse | any> => {
		const url = `/v1/all-remittance-printing/rq-remittance-xlsx?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&managed_by=${managedBy}`;
		const response: any = await http.get(url, {
			responseType: "arraybuffer",
		});

		if (response.status === 201) {
			return response.data;
		} else if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			const text = new TextDecoder().decode(response.data);
			const responseObject = JSON.parse(text);
			let response400 = {
				...response,
				data: responseObject,
			};
			return response400;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}
		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
};
